import type { FullTagDescription, TagDescription } from './rtk-query-types';

/**
 * Приводит произвольный тег к полному формату (в виде объекта)
 * @param tag Тег
 * @returns Тег в полном формате (в виде объекта)
 */
export function expandTag(tag: TagDescription<string>): FullTagDescription<string> {
    return typeof tag === 'string' ? { type: tag } : tag;
}

/**
 * Сравнивает два тега
 * @param tagA Первый тег
 * @param tagB Второй тег
 * @returns true, если теги совпадают
 */
export function isTagsEqual(tagA: TagDescription<string>, tagB: TagDescription<string>) {
    const expandedTagA = expandTag(tagA);
    const expandedTagB = expandTag(tagB);

    return expandedTagA.type === expandedTagB.type && String(expandedTagA.id) === String(expandedTagB.id);
}
